/* normal null is not working correctly in template if used as form value */
export const TEMPLATE_NULL = 'null';

export const ALMOST_ONE_DAY_HOURS = 23;
export const ALMOST_ONE_HOUR_MINUTES = 59;
